// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLICK_HERE_TO_ENTER_DESCRIPTION = "Klikni sem a zadaj popis";
